<form clrStepper [formGroup]="notificationForm" (ngSubmit)="onSubmit()">
  <clr-stepper-panel formGroupName="stepI">
    <clr-step-title>Empfänger</clr-step-title>
    <clr-step-description>Name, Kurzbeschreibung, Zeitraum</clr-step-description>
    <clr-step-content>

      <app-request-company-search (submitSupplierNumber)="preFillRow($event)"></app-request-company-search>

      <clr-input-container>
        <label>Firma</label>
        <input clrInput name="company_name" formControlName="company_name" />
      </clr-input-container>
      <clr-input-container>
        <label>Straße</label>
        <input clrInput formControlName="street" />
      </clr-input-container>
      <clr-input-container>
        <label>Stadt</label>
        <input clrInput formControlName="city" />
      </clr-input-container>
      <clr-input-container>
        <label>PLZ</label>
        <input clrInput formControlName="postcode" />
      </clr-input-container>
      <app-country-select controlName="country" label="Land" />
      <clr-input-container>
        <label>Betreff</label>
        <input clrInput formControlName="subject" />
      </clr-input-container>
      <clr-date-container>
        <label>Datum</label>
        <input clrDate type="date" placeholder="{{ notificationData?.notification_date | date: 'dd.MM.yyyy' }}" formControlName="notification_date" />
      </clr-date-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/notification/details', projectId, jobId, notificationId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepII">
    <clr-step-title>Bearbeiter</clr-step-title>
    <clr-step-description>(seitens PPS)</clr-step-description>
    <clr-step-content>
      <div>Projektnummer {{ projectId }}</div>

      <clr-radio-container clrInline>
        <clr-radio-wrapper *ngFor="let employee of staff">
          <input type="radio" clrRadio formControlName="employee_phm" [value]="employee.staff_id" />
          <label *ngIf="employee.staff_id !== projectStaff()">{{ employee.firstname }} {{ employee.lastname }}</label>
          <label *ngIf="employee.staff_id === projectStaff()" class="leader"><b>{{ employee.firstname }} {{ employee.lastname }}</b></label>
        </clr-radio-wrapper>
      </clr-radio-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="next">Weiter</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/notification/details', projectId, jobId, notificationId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>

  <clr-stepper-panel formGroupName="stepIII">
    <clr-step-title>Ansprechpartner</clr-step-title>
    <clr-step-description>(seitens Empfänger)</clr-step-description>
    <clr-step-content>
      <clr-select-container>
        <label>Ansprechpartner</label>
        <select clrSelect formControlName="employee_leader">
          <option value="">Bitte wählen...</option>
          <option *ngFor="let person of persons" [value]="person.pid">{{ person.lastname }}, {{ person.firstname }}</option>
        </select>
      </clr-select-container>
      <br>
      <div class="btn-group btn-primary btn-sm">
        <button class="btn" clrStepButton="submit">Änderungen speichern</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="!isUpdateMode" [routerLink]="['/job/details', projectId, jobId]">abbrechen</button>
        <button class="btn btn-warning-outline btn-sm" *ngIf="isUpdateMode" [routerLink]="['/notification/details', projectId, jobId, notificationId]">abbrechen</button>
      </div>
    </clr-step-content>
  </clr-stepper-panel>
</form>
